<script lang="ts">
    import type { FormSubmitEvent } from "../types/form";
    import type {ContactSummary} from "../../models/contact.summary";
    import {Link} from "svelte-navigator";
    import {get, post} from "../services/http.service";

    async function getContacts() {
      const contacts = await get('api/contacts');
      return contacts;
    }

    let contacts: ContactSummary[] = [];

    getContacts().then(x => contacts = x);

    async function handleSubmit(ev: FormSubmitEvent) {
      const form = ev.target as HTMLFormElement;
      const formData = new FormData(form);
      const newContact = await post('api/contacts', {
        name: formData.get('name'),
        company: formData.get('company'),
      });

      contacts = [...contacts, newContact];

      form.reset();
    }
</script>

<svelte:head>
    <title>Your contacts</title>
</svelte:head>

<h1>Your contacts</h1>

<ul>
    {#each contacts as {id, name, company}}
        <li>
            <Link to="/contacts/{id}">
                {name} ({company})
            </Link>
        </li>
    {/each}
</ul>

<form on:submit|preventDefault={handleSubmit}>
    <fieldset>
        <legend>Add a contact</legend>

        <p>
            <input type="text" name="name" required minlength="2" placeholder="Name"/>
        </p>
        <p>
            <input type="text" name="company" required minlength="2" placeholder="Company"/>
        </p>
        <p>
            <button type="submit">Save</button>
        </p>
    </fieldset>
</form>
